// src/components/ui/BlueButton.js
import styled from 'styled-components';

const BlueButton = styled.button`
  background-color: #E0F0FF;
  color: #007BFF;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #cce4fc;
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

export default BlueButton;
